import React from "react";
import { useLocalization } from "./LocalizationContext";
import en from "./locales/en.json";
import ee from "./locales/ee.json";

const translations = { en, ee };

const Translate = ({ id }) => {
    const { language } = useLocalization();
    return <>{translations[language][id]}</>;
};

export default Translate;